import { JWTService } from '@/shared/services/jwt'
import ClientFactory from '@/shared/factories/client'
import redirecionaSemSessao from './redirecionaSemSessao'

// Não setar Content-Type aqui — quando o body é FormData, axios 1.x detecta
// e deixa o XHR/browser setar `multipart/form-data; boundary=...XXXXX` automaticamente.
// Setar `multipart/form-data` sem boundary quebra o parser do ASP.NET Core (500).
const APIClientUpload = ClientFactory.New(
  process.env.APIBaseURLAccess,
  { withCredentials: true }
)

// Dev: enviar Bearer do localStorage — fluxo de login local
// Prod/aceite: sem Bearer — cookie zcloud_token enviado via withCredentials
if (process.env.NODE_ENV === 'development') {
  APIClientUpload.interceptors.request.use((request) => {
    const token = JWTService.GetToken()

    /* eslint-disable-next-line */
    if (token) request.headers.Authorization = `Bearer ${token}`

    return request
  }, error => Promise.reject(error))
}

APIClientUpload.interceptors.response.use(response => response, redirecionaSemSessao)

export default APIClientUpload



// WEBPACK FOOTER //
// ./src/shared/http/clients/apiupload.js